<template>
  <header id="header">
    <b-container class="px-md-0">
      <b-row
        align-v="center"
        class="justify-content-md-between"
      >
        <b-col
          class="text-center text-md-left"
          md="5"
        >
          <h1 class="d-inline-block">
            <router-link :to="`/${$t('lang')}/`">
              <img
                alt=""
                :src="`${$t('baseurl')}img/icons/pad.svg`"
              />
              <span v-html="$t('color.pad')"></span>
            </router-link>
          </h1>
        </b-col>
        <b-col
          class="d-flex justify-content-center justify-content-md-end"
          md="7"
        >
          <b-nav
            class="list-unstyled justify-content-center"
            pills
          >
            <b-nav-text>
              <b-button
                href="https://mypads2.framapad.org/mypads/?/subscribe"
                variant="outline-secondary text-uppercase mx-1"
                v-html="$t('hos.header.signup')"
              />
            </b-nav-text>
            <b-nav-text>
              <b-dropdown
                right
                variant="primary text-uppercase mx-1"
                :html="$t('hos.header.signin')"
              >
                <b-dropdown-item
                  class="bg-none"
                  href="https://mypads.framapad.org/mypads/?/login"
                >
                  <span v-html="$t('hos.header.mypads', { date: date('2020-03-18') })"></span>
                </b-dropdown-item>
                <b-dropdown-item
                  class="bg-none"
                  href="https://mypads2.framapad.org/mypads/?/login"
                >
                  <span v-html="$t('hos.header.mypads2', { date: date('2020-03-18') })"></span>
                </b-dropdown-item>
              </b-dropdown>
            </b-nav-text>
            <b-nav-text
              class="nav-item"
              tag="li"
            >
              <I18n />
            </b-nav-text>
          </b-nav>
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<script>
import I18n from '../../commons/components/I18n.vue';

export default {
  components: {
    I18n,
  },

  methods: {
    date(date) {
      return new Date(this.$t(date)).toLocaleDateString(this.$t('lang'), {
        year: 'numeric',
        month: 'long',
      });
    },
  },
};
</script>

<style lang="scss">
  #header {
    background: #fff;
    border-bottom: 1px solid var(--f-g4);

    h1 {
      margin: 0;
      line-height: normal;
      font-size: 2rem;

      a {
        text-decoration: none;
        display: flex;
        align-items: center;

        img {
          width: 64px;
          height: 64px;
          padding: .25rem .25rem .25rem 0;
        }
      }
    }

    .btn {
      border: transparent;
    }
  }
</style>
